import AuthService from "../services/auth.service";

const user = JSON.parse(localStorage.getItem("user"));
// let user = null;
// try {
//   const userStr = localStorage.getItem("user");
//   if (userStr && userStr !== "undefined") {
//     user = JSON.parse(userStr);
//   }
// } catch (e) {
//   user = null;
// }

const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

export const auth = {
  namespaced: true,
  state: initialState,
  getters: {
    currentUserSafe(state) {
      // Return a safe empty user object if not logged in
      return (
        state.user || {
          id: null,
          username: "",
          email: "",
          roles: [],
          branches: [],
          dept: [],
          profile: "",
        }
      );
    },
  },
  actions: {
    async login({ commit }, userData) {
      return AuthService.login(userData).then(
        async (user) => {
          commit("loginSuccess", user);
          // Update LastSeen after login
          if (user && user.id) {
            try {
              await AuthService.updateLastSeen(user.id);
            } catch (e) {
              // Ignore errors, non-blocking
            }
          }
          return Promise.resolve(user);
        },
        (error) => {
          commit("loginFailure");
          return Promise.reject(error);
        }
      );
    },
    async logout({ commit }) {
      // Fire-and-forget backend logout, but don't await
      AuthService.logout().catch(() => {});
      commit("logout");
    },
    register({ commit }, user) {
      return AuthService.register(user).then(
        (response) => {
          commit("registerSuccess");
          return Promise.resolve(response.data);
        },
        (error) => {
          commit("registerFailure");
          return Promise.reject(error);
        }
      );
    },
    refreshToken({ commit }, accessToken) {
      commit("refreshToken", accessToken);
    },
    async ensureValidSession({ commit, dispatch }) {
      const TokenService = require("../services/token.service").default;
      const AuthService = require("../services/auth.service").default;
      if (TokenService.isAccessTokenExpired()) {
        try {
          const newToken = await AuthService.refreshAccessToken();
          commit("refreshToken", newToken);
        } catch {
          dispatch("logout");
        }
      }
    },
  },
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    },
    refreshToken(state, accessToken) {
      state.status.loggedIn = true;
      state.user = { ...state.user, accessToken: accessToken };
    },
  },
};
